import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  clearFilters
} from 'app/actions/filters';

const useFiltersButton = props => {
  const {
    agGrid,
    quickEdit,
    resource
  } = props;

  const dispatch = useDispatch();

  // setup onClick callback to toggle filters
  const onClick = () => {
    let enable = !agGrid.filtersActiveRef.current;

    agGrid.toggleFilters();

    if (!enable) {
      dispatch(clearFilters({ resource }));
    }
  }

  // disable if quick edit mode is active
  const disabled = quickEdit.active;

  return {
    onClick,
    disabled
  }
}

export default useFiltersButton;
